export const headerContentHeight = 56
export const subPageNavHeight = 40
export const headerHeight = headerContentHeight + subPageNavHeight
export const filterBarHeight = 56
export const largeFilterBarHeight = 75
export const mainNavWidth = 96
export const tableOfContentsWidth = 220
export const pageHeaderHeight = headerContentHeight + filterBarHeight
export const bannerHeight = 55
export const appHeaderHeight = 47
export const navBarWidth = 60
